import { TCommentProps } from '../CommentsList';
import { useGetT2Comments } from './useGetT2Comments';
import { sortComments } from '../services/comments';

type TUseGetComments = {
  articleId: string;
  userId?: string;
  loadingAuthenticatedUserStatus: boolean;
};

export const useGetComments = ({
  articleId,
  userId,
  loadingAuthenticatedUserStatus,
}: TUseGetComments): {
  loading: boolean;
  comments: TCommentProps[];
  error: any;
  getT2Comments: Function;
  shouldFetchT2Comments: boolean;
} => {
  const {
    t2CommentsLoading,
    t2CommentsError,
    t2Comments = [],
    getT2Comments,
    shouldFetchT2Comments,
  } = useGetT2Comments({
    articleId,
    userId,
    loadingAuthenticatedUserStatus,
  });

  const comments = sortComments(t2Comments);

  return {
    loading: t2CommentsLoading,
    error: t2CommentsError,
    comments,
    getT2Comments,
    shouldFetchT2Comments,
  };
};
